export default "__VITE_ASSET__wARiMboD__"